import http from "./http";
export const baseUrl = "/v1/api/app";
export const baseUrl2 = "/v2/api/platform";
export const baseUrl3 = "/v1/api/platform";
export const baseUrl4 = "/v1/api/auth";

const { get, post } = http;
const getAllPage = (params: any) => post(`${baseUrl}/general/all/page`, params); // 查询所有应用列表
const getAllNoPage = (params: any) => post(`${baseUrl}/general/list`, params); // 查询所有应用列表不带分页
const allAdd = (params: any) => post(`${baseUrl}/general/create`, params); // 应用创建
const allRepeatName = (params: any) => post(`${baseUrl}/general/name/exist`, params); // 检查应用名称是否存在，存在时返回true，不存在时返回false
const allRepeatPackageName = (params: any) => post(`${baseUrl}/general/packageName/exist`, params); // 检查应用包名是否存在，存在时返回true，不存在时返回false
const getAtomicPage = (params: any) => post(`${baseUrl}/atomic/page`, params); // 查询原子化列表
const getAppPage = (params: any) => post(`${baseUrl}/app/page`, params); // 查询应用列表
const getEnginePage = (params: any) => post(`${baseUrl}/engine/page`, params); // 查询开鸿应用引擎列表
const getAcsPage = (params: any) => post(`${baseUrl}/acs/page`, params); // 查询安卓生态应用列表
const getComponentPage = (params: any) => post(`${baseUrl}/component/page`, params); // 查询组件列表
const getKcsPage = (params: any) => post(`${baseUrl}/kcs/page`, params); // 查询Linux应用列表
const getPsoPage = (params: any) => post(`${baseUrl}/pso/page`, params); // 查询IDE插件应用列表
const getToolboxPage = (params: any) => post(`${baseUrl}/toolbox/page`, params); // 查询工具应用列表
const atomicRepeatName = (params: any) => post(`${baseUrl}/atomic/name/exist`, params); // 检查原子化名称是否存在,存在时返回true,不存在时返回false
const appRepeatName = (params: any) => post(`${baseUrl}/app/name/exist`, params); // 检查应用名称是否存在,存在时返回true,不存在时返回false
const engineRepeatName = (params: any) => post(`${baseUrl}/engine/name/exist`, params); // 检查开鸿应用引擎名称是否存在,存在时返回true,不存在时返回false
const acsRepeatName = (params: any) => post(`${baseUrl}/acs/name/exist`, params); // 检查安卓生态应用名称是否存在,存在时返回true,不存在时返回false
const componentRepeatName = (params: any) => post(`${baseUrl}/component/name/exist`, params); // 检查组件名称是否存在,存在时返回true,不存在时返回false
const kcsRepeatName = (params: any) => post(`${baseUrl}/kcs/name/exist`, params); // 检查Linux应用名称是否存在,存在时返回true,不存在时返回false
const psoRepeatName = (params: any) => post(`${baseUrl}/pso/name/exist`, params); // 检查组件名称是否存在,存在时返回true,不存在时返回false
const toolboxRepeatName = (params: any) => post(`${baseUrl}/toolbox/name/exist`, params); // 检查Linux应用名称是否存在,存在时返回true,不存在时返回false
const atomicRepeatPackageName = (params: any) => post(`${baseUrl}/atomic/packageName/exist`, params); // 检查原子化包名是否存在,存在时返回true,不存在时返回false
const appRepeatPackageName = (params: any) => post(`${baseUrl}/app/packageName/exist`, params); // 检查应用包名是否存在,存在时返回true,不存在时返回false
const engineRepeatPackageName = (params: any) => post(`${baseUrl}/engine/packageName/exist`, params); // 检查开鸿应用引擎包名是否存在，存在时返回true，不存在时返回false
const acsRepeatPackageName = (params: any) => post(`${baseUrl}/acs/packageName/exist`, params); // 检查安卓生态应用包名是否存在，存在时返回true，不存在时返回false
const componentRepeatPackageName = (params: any) => post(`${baseUrl}/component/packageName/exist`, params); // 检查组件包名是否存在，存在时返回true，不存在时返回false
const kcsRepeatPackageName = (params: any) => post(`${baseUrl}/kcs/packageName/exist`, params); // 检查Linux应用包名是否存在，存在时返回true，不存在时返回false
const psoRepeatPackageName = (params: any) => post(`${baseUrl}/pso/packageName/exist`, params); // 检查IDE插件应用包名是否存在，存在时返回true，不存在时返回false
const toolboxRepeatPackageName = (params: any) => post(`${baseUrl}/toolbox/packageName/exist`, params); // 检查工具应用包名是否存在，存在时返回true，不存在时返回false

const atomicAdd = (params: any) => post(`${baseUrl}/atomic/create`, params); // 创建原子化
const appAdd = (params: any) => post(`${baseUrl}/app/create`, params); // 创建应用
const engineAdd = (params: any) => post(`${baseUrl}/engine/create`, params); // 开鸿应用引擎创建
const acsAdd = (params: any) => post(`${baseUrl}/acs/create`, params); // 安卓生态应用创建
const componentAdd = (params: any) => post(`${baseUrl}/component/create`, params); // 组件创建
const kcsAdd = (params: any) => post(`${baseUrl}/kcs/create`, params); // Linux应用创建
const psoAdd = (params: any) => post(`${baseUrl}/pso/create`, params); // IDE插件创建
const toolboxAdd = (params: any) => post(`${baseUrl}/toolbox/create`, params); // 工具应用创建
const defaultPrivate = (params: any) => get(`${baseUrl2}/file/default/private/url`, { params }); //默认私有文件下载地址

const getInstallData = (params: any) => post(`${baseUrl3}/app/statistics/install/trend`, params); // 应用的安装次数趋势以及比上周期增长率
const getUninstallData = (params: any) => post(`${baseUrl3}/app/statistics/uninstall/trend`, params); // 应用的卸載次数趋势以及比上周期增长率
const getOpenData = (params: any) => post(`${baseUrl3}/app/statistics/open/trend`, params); // 应用的打开次数趋势以及比上周期增长率
const getUseData = (params: any) => post(`${baseUrl3}/app/statistics/use/trend`, params); // 应用的平均使用时长趋势以及比上周期增长率
const getAuthConfig = (params?: any) => post(`${baseUrl4}/super/auth/getConfig`, params); // 获取cookie等配置项

//自定义类型相关通用接口
const reqAddApp = (params: any) => post(`${baseUrl}/custom/app/create`, params); // 创建应用

export default {
  getAllPage,
  getAllNoPage,
  allAdd,
  allRepeatName,
  allRepeatPackageName,
  getAtomicPage,
  getAppPage,
  getEnginePage,
  getAcsPage,
  getComponentPage,
  getKcsPage,
  getPsoPage,
  getToolboxPage,
  atomicRepeatName,
  appRepeatName,
  engineRepeatName,
  acsRepeatName,
  componentRepeatName,
  kcsRepeatName,
  psoRepeatName,
  toolboxRepeatName,
  atomicRepeatPackageName,
  appRepeatPackageName,
  engineRepeatPackageName,
  acsRepeatPackageName,
  componentRepeatPackageName,
  kcsRepeatPackageName,
  psoRepeatPackageName,
  toolboxRepeatPackageName,
  atomicAdd,
  appAdd,
  engineAdd,
  acsAdd,
  componentAdd,
  kcsAdd,
  psoAdd,
  toolboxAdd,
  defaultPrivate,
  getInstallData,
  getUninstallData,
  getOpenData,
  getUseData,
  getAuthConfig,
  reqAddApp,
};
